/* tslint:disable */
/* eslint-disable */
/**
 * EN.ClientContract
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ControlPanelCardDto } from '../models';
/**
 * ControlPanelApi - axios parameter creator
 * @export
 */
export const ControlPanelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get favourized divece control panel card list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllControlPanel: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ControlPanel/Devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication XApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControlPanelApi - functional programming interface
 * @export
 */
export const ControlPanelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControlPanelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get favourized divece control panel card list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllControlPanel(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ControlPanelCardDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllControlPanel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ControlPanelApi - factory interface
 * @export
 */
export const ControlPanelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControlPanelApiFp(configuration)
    return {
        /**
         * 
         * @summary Get favourized divece control panel card list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllControlPanel(options?: any): AxiosPromise<Array<ControlPanelCardDto>> {
            return localVarFp.getAllControlPanel(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ControlPanelApi - object-oriented interface
 * @export
 * @class ControlPanelApi
 * @extends {BaseAPI}
 */
export class ControlPanelApi extends BaseAPI {
    /**
     * 
     * @summary Get favourized divece control panel card list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlPanelApi
     */
    public getAllControlPanel(options?: any) {
        return ControlPanelApiFp(this.configuration).getAllControlPanel(options).then((request) => request(this.axios, this.basePath));
    }
}
